import React, { useEffect, useState } from 'react';
import { ResponsiveChoropleth } from '@nivo/geo';
import LoadingScreen from '../../LoadingScreen';
import {geoFeatures} from './geoFeatureData';
import {mockGeographyData as data} from './geoData';



const GeoMap = ({geoData}) => {
  const [loading,setLoading] = useState();
  const [domain,setDomain] = useState();
  const [formattedData,setFormattedData] = useState(null);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {

    const values = geoData.map((country) => country.totalTickets);
    const maxValue = Math.max(...values);

    setDomain([0, maxValue]);

    

    setFormattedData(geoData.map(item => ({
      id: item._id, 
      value: item.totalTickets,
    })));


  

  }, []);



  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div style={{ height: '25vh', width: '100%' }}>
          <h4 style={{ marginTop: '-2em', marginBottom:"0.3em" }}>Ticket sales popularity by country</h4>
          <ResponsiveChoropleth
            data={formattedData}
            colors="nivo"
            features={geoFeatures.features}
            margin={{ top: 80, right: 0, bottom: 0, left: 0 }}
            domain={domain}
            unknownColor="#666666"
            label="properties.name"
            valueFormat=".2s"
            projectionScale={isMobile? 110 : 130}
            projectionTranslation={[0.5, 0.5]}
            projectionRotation={[0, 0, 0]}
            borderWidth={1.5}
            borderColor="#ffffff"
            legends={[
              {
                anchor: 'bottom',
                direction: 'column',
                justify: true,
                translateX: -300,
                translateY: -80,
                itemsSpacing: 0,
                itemWidth: 64,
                itemHeight: 18,
                itemDirection: 'left-to-right',
                itemTextColor: 'black',
                itemOpacity: 0.85,
                symbolSize: 18,
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemTextColor: '#ffffff',
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default GeoMap;
